import { render, staticRenderFns } from "./Ingame.vue?vue&type=template&id=63788ded"
import script from "./Ingame.vue?vue&type=script&lang=js"
export * from "./Ingame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports